import { render, staticRenderFns } from "./holiday_detail.vue?vue&type=template&id=6cc68b10&scoped=true"
import script from "./holiday_detail.vue?vue&type=script&lang=js"
export * from "./holiday_detail.vue?vue&type=script&lang=js"
import style0 from "./holiday_detail.vue?vue&type=style&index=0&id=6cc68b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc68b10",
  null
  
)

export default component.exports